import i18next from 'i18next';
import { format, isValid, parseISO } from 'date-fns';
import { mapUserLocaleToShorthand } from 'i18n/mapUserLocaleToShorthand';

export default (timeStr: string) => {
  const date = parseISO(timeStr);

  if (!isValid(date)) {
    return null;
  }

  let formattingString: string;

  switch (i18next.language) {
    case 'en-GB':
      formattingString = 'h:mm aaa';
      break;

    default:
      formattingString = 'p';
  }

  return format(date, formattingString, {
    locale: mapUserLocaleToShorthand(),
  }).toLowerCase();
};
